"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTimelockFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TokenTimelockFactory = /** @class */ (function (_super) {
    __extends(TokenTimelockFactory, _super);
    function TokenTimelockFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TokenTimelockFactory.prototype.deploy = function (token_, beneficiary_, releaseTime_, overrides) {
        return _super.prototype.deploy.call(this, token_, beneficiary_, releaseTime_, overrides || {});
    };
    TokenTimelockFactory.prototype.getDeployTransaction = function (token_, beneficiary_, releaseTime_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, token_, beneficiary_, releaseTime_, overrides || {});
    };
    TokenTimelockFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TokenTimelockFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TokenTimelockFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TokenTimelockFactory;
}(contracts_1.ContractFactory));
exports.TokenTimelockFactory = TokenTimelockFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'contract IERC20',
                name: 'token_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'beneficiary_',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'releaseTime_',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'beneficiary',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'release',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'releaseTime',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'token',
        outputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TokenTimelockFactory.js.map